import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {useHttpClient} from '../../../../common/hook/http';
import NoContent from '../../../../common/component/NoContent/NoContent';
import Loader from '../../../../common/component/Loader/Loader';

import {useToast} from '../../../../common/hook/toast';

import OffcanvasTickets from '../../../offcanvas/Tickets/Tickets';

import Pagination from '../../../../common/component/Pagination/Pagination';

import {ListGroup, Row, Col, Badge, Button, Spinner} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './Tickets.scss'

const Tickets = () => {
    const {callAPI} = useHttpClient()
    const {callToast} = useToast()

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [pagination, setPagination] = useState(1)
    const [paginationDisabled, setPaginationDisabled] = useState(false)

    const [data, setData] = useState(null)

    const fetchData = async page => {

        setPaginationDisabled(true)

        try {
            const responseData = await callAPI(
                `user/tickets/${Number.isInteger(page) ? page : pagination}`
            );

            if (responseData.message) {

            } else {

                Number.isInteger(page) && setPagination(page)
                setPaginationDisabled(false)

                setData(responseData.result)

            }

        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {

        fetchData()

    }, []);

    // -----------------------------------------------------------------------------------------------------------------

    const [offcanvasData, setOffcanvasData] = useState(null);
    const [offcanvasTicketsShow, setOffcanvasTicketsShow] = useState(false);

    const offcanvasTicketsShowHandler = item => {

        setOffcanvasData(() => {
            return item
        })

        setOffcanvasTicketsShow(true);

    }

    // -----------------------------------------------------------------------------------------------------------------

    const pdfHandler = async (e, authority) => {

        e.target.closest('.btn').querySelector('i').classList.add('opacity-100')

        try {
            const responseData = await callAPI(
                `ticketweb/getPdf/${authority}`
            );

            e.target.closest('.btn').querySelector('i').classList.remove('opacity-100')

            if (responseData.message) {
                callToast('secondary', null, null, responseData.message);
            } else {

                // const blobUrl = window.URL.createObjectURL(
                //     new Blob([responseData]),
                // );
                const link = document.createElement('a');
                // link.href = blobUrl;
                link.href = responseData.result.link;
                // link.setAttribute('download', `mica-mall-reservation-${props.location.state.bank['ep'].id}.pdf`,);
                link.download = 'micamall-ticket.pdf';
                // link.setAttribute('download',"download")

                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);

            }

        } catch (e) {
            e.target.closest('.btn').querySelector('i').classList.remove('opacity-100')
            console.error(e);
        }

    };

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <div id="pageAccountTickets" className={data?.orders?.length && data?.totalPages > 1 ? 'has-page-footer' : null}>
                <Row>
                    <Col xs={12}>
                        {
                            data ? (
                                data.orders.length ? (
                                    <>
                                        <ListGroup variant="flush" className="my-n2">
                                        {
                                            data.orders.map(item => {
                                                return (
                                                    <ListGroup.Item as="li" className="px-0 d-flex align-items-center border-bottom-0" key={item.id}>
                                                        <figure className="mb-0 me-3 ratio ratio-1x1 bg-elevate-1 d-none d-sm-block rounded-square" style={{backgroundImage: 'url()'}}/>
                                                        <div className="me-auto">
                                                            <div className="fw-500 text-primary fs-18px">{item.name}</div>
                                                            <div className="mb-1 text-primary d-flex align-items-center flex-wrap">
                                                                {
                                                                    !item.paid && (<Badge bg="danger" className="fw-500 me-2 fs-11 rounded-0">پرداخت نشده</Badge>)
                                                                }
                                                                <span>{item.type === 'normal' ? `${item.reserve_count} بلیط ${item.typeTitle}` : `${item.reserve_count} ${item.typeTitle}`}</span>
                                                            </div>
                                                            <div>{item.reserve_date}<span className="ms-2">ساعت </span>{item.reserve_time} تا {item.endTime}</div>
                                                        </div>
                                                        {
                                                            item.out_of_date ? (
                                                                <Button variant="link" className="flex-shrink-0 ms-3 bg-elevate-1 text-white text-opacity-60 text-decoration-none" onClick={() => offcanvasTicketsShowHandler(item)}>منقضی شده</Button>
                                                            ) : (
                                                                item.paid ? (
                                                                    <Button className="flex-shrink-0 ms-3 btn-icon px-sm-3 btn-loading" onClick={() => pdfHandler(item.authority)}>
                                                                        <Spinner as="i" animation="border" size="sm" className="border-1"/>
                                                                        <IconFi.FiDownload size={24} className="sw-1"/>
                                                                        <span className="d-none d-sm-inline ms-2">دریافت بلیط</span>
                                                                    </Button>
                                                                ) : (
                                                                    <Button as={Link} to={`/entertain/ticket-order/${item.entertainment_place_id}?step=3`} state={{entertainmentPlace: item, tax: data.tax}} className="flex-shrink-0 ms-3">پرداخت</Button>
                                                                )
                                                            )
                                                        }
                                                    </ListGroup.Item>
                                                )
                                            })
                                        }
                                    </ListGroup>
                                        {
                                            data.totalPages > 1 && (
                                                <div className="py-2 py-md-0 page-footer">
                                                    <Pagination pagination={pagination} paginationDisabled={paginationDisabled} totalPages={data.totalPages} onClick={res => fetchData(res)}/>
                                                </div>
                                            )
                                        }
                                    </>
                                ) : (
                                    <div className="py-5 my-5">
                                        <NoContent text={`اطلاعاتی وجود ندارد`}/>
                                    </div>
                                )
                            ) : (
                                <div className="py-5 my-5">
                                    <Loader text="در حال دریافت اطلاعات"/>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            </div>
            {
                data ? (
                    <OffcanvasTickets show={offcanvasTicketsShow} onHide={() => setOffcanvasTicketsShow(false)} data={offcanvasData}/>
                ) : (
                    <></>
                )
            }
        </>
    )
}

export default Tickets;